export default __webpack_public_path__ + "static/media/info_icon.6ca8384a.svg";